import {createFileRoute} from '@tanstack/react-router'
import MexicanosView_Create from "../../../mexicanos/MexicanosView_Create.tsx";

export const Route = createFileRoute('/_app/mexicanos/create')({
    component: RouteComponent,
})

function RouteComponent() {
    return <MexicanosView_Create />
}
